var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mag-link",class:_vm.cls,attrs:{"href":_vm.href},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }